import '../../../../es/style/index.less';
import './index.less';
// style dependencies
import '../../trigger-field/style';
import '../../spin/style';
import '../../text-field/style';
import '../../../../es/menu/style';
import '../../../../es/checkbox/style';
import '../../../../es/tag/style';
